export default __webpack_public_path__ + "static/media/javascript.218515fe.svg";